export const messagesTypes = {
    SEND_MESSAGE : 'SEND_MESSAGE_MESSAGES',
    RECEIVE_MESSAGE : 'RECEIVE_MESSAGE_MESSAGES',
    UPDATE_MESSAGE : 'UPDATE_MESSAGE_MESSAGES',
    LOAD_MESSAGES : 'LOAD_MESSAGES_MESSAGES',
    LOAD_FRIENDS : 'LOAD_FRIENDS_MESSAGES',
    CLEAR_UNREAD_MESSAGES : 'CLEAR_UNREAD_MESSAGES_MESSAGES',
    RESET : 'RESET'
};